import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Sale } from 'src/app/models/sale.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-sale]',
  template: `
    <td class="align-middle">{{sale?.sale_number}}</td>
    <td class="align-middle text-center">{{sale?.total_amount | currency}}</td>
    <td class="align-middle text-center">
      <span [class]="getSaleStatusBadge(sale?.status)">
        {{getSaleStatusLabel(sale?.status)}}
      </span>
    </td>
    <td class="align-middle text-center">{{sale?.notes}}</td>
    <td class="align-middle text-center">{{sale?.created_at | date:'short'}}</td>
    <td class="align-middle text-center">
      <button class="btn btn-sm btn-primary me-2" (click)="editSale(sale!)">
        <fa-icon [icon]="icons.faEdit"></fa-icon>
      </button>
      <button class="btn btn-sm btn-danger" (click)="deleteSale(sale!)" *ngIf="canDeleteSale(sale!)">
        <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
      </button>
    </td>
  `,
  styleUrls: []
})
export class TrSaleComponent {
  @Input() sale: Sale | null = null;

  constructor(
    private inventoryService: InventoryService,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService
  ) {}

  getSaleStatusLabel(status: number | undefined): string {
    switch (status) {
      case 0: return 'Pendiente';
      case 1: return 'Completada';
      case 2: return 'Cancelada';
      default: return 'Desconocido';
    }
  }

  getSaleStatusBadge(status: number | undefined): string {
    switch (status) {
      case 0: return 'badge bg-warning';
      case 1: return 'badge bg-success';
      case 2: return 'badge bg-danger';
      default: return 'badge bg-secondary';
    }
  }



  editSale(sale: Sale) {
    // Implement navigation to edit sale component
  }

  deleteSale(sale: Sale) {
    if (confirm('Are you sure you want to delete this sale?')) {
      this.inventoryService.deleteSale(sale.id!).subscribe({
        next: () => {
          this.toastr.success('Sale deleted successfully');
          // this.loadSales();
        },
        error: (error) => {
          this.toastr.error('Error deleting sale');
        }
      });
    }
  }

  canDeleteSale(sale: Sale): boolean {
    return this.authService.hasPermission('can_delete_sale') && sale.status === 0;
  }
}
